import React, { useState } from 'react';
import { ApplyButton, CouponName } from './styled';
import { images } from '../../../../Constants/ImageUrls';
import { useRouter } from 'next/router';
import { getSearchParams } from '../../../Parenting/common';
import { getRouterLocale } from '../../../../Utils/i18Utils/constant';

function CartCouponSection(props) {
  const {
    applyCouponClickHandler,
    data,
    index,
    userAppliedOffer,
    toggle,
    hideViewAll,
  } = props;
  // const { day, month, elapsedDays } = generateTimeString(data?.expire_date);
  const appliedOffer = userAppliedOffer?.term_id === data?.term_id;
  const classNameAdd = appliedOffer ? 'opaq' : '';
  const router = useRouter();
  const web_url = data?.cta?.web_offer_url || '';
  const cta_text = data?.cta?.text;
  const [clickEffect, setClickEffect] = useState('');
  const handleViewAllProducts = (e) => {
    e.stopPropagation();
    setClickEffect('low_opacity');
    setTimeout(() => {
      router.push(web_url + getSearchParams(), '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };
  return (
    <li
      key={`couponList${index}`}
      onClick={() => applyCouponClickHandler(data)}
      className={toggle ? `li show ${classNameAdd}` : `li ${classNameAdd}`}
    >
      <div className="valid_till_cart">
        <div className="desc">{data.description}</div>
      </div>
      {data?.conditions?.en ? (
        <div className="applicable_on">{data?.conditions?.en}</div>
      ) : null}
      {cta_text && !hideViewAll ? (
        <div
          className={`view_all_products ${clickEffect}`}
          onClick={handleViewAllProducts}
        >
          {cta_text}{' '}
          <img src={images.arrow_verm_right} alt="verm_arrow" width={16} />
        </div>
      ) : null}

      <label className="dropdown_option">
        <div className="coupon_image">
          <img
            src={images.coupon_spike}
            alt="left_spike"
            className="left_spike"
          />
          <CouponName>{data?.code} </CouponName>
          <img
            src={images.coupon_spike}
            alt="right_spike"
            className="right_spike"
          />
        </div>

        <ApplyButton>{appliedOffer ? 'APPLIED' : 'APPLY'}</ApplyButton>
      </label>
    </li>
  );
}

export default CartCouponSection;
